import en from './en.json'
import it from './it.json'

export const emailTextsTranslations = {
	en,
	it
} as const
